import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    ...utils.requestTypes('UNCHECKED_IMPACTING_POLICY_COUNT'),
};

export const actions = {
    unchecked_impacting_policy_countSet: (obj) => utils.action(types.UNCHECKED_IMPACTING_POLICY_COUNT_SET, obj),
};

const initialState = fromJS({
    loaded: 'loading',
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.UNCHECKED_IMPACTING_POLICY_COUNT_SET:
        if (action.payload.impacting_policies_count) {
            return fromJS({
                uncheckedImpactingPolicyCount: action.payload.impacting_policies_count,
                total: action.payload.total,
                loaded: 'complete',
            });
        }

        return fromJS({
            uncheckedImpactingPolicyCount: 0,
            loaded: 'empty',
        });

    case types.UNCHECKED_IMPACTING_POLICY_COUNT_RESET:
        return initialState;

    default:
        return state;
    }
};

const getUncheckedImpactingPolicyCount = (state) => state.get('app').get('uncheckedImpactingPolicyCount');

export const selectors = {
    getUncheckedImpactingPolicyCount: getUncheckedImpactingPolicyCount,
};
